import * as XLSX from 'xlsx';

export const TRAFFIC_LIGHT_STATES = [
  {value: 'open', label: 'Con plazo disponible'},
  {value: 'due_soon', label: 'Próxima a vencer'},
  {value: 'overdue', label: 'Vencida'},
  {value: 'responded', label: 'Respondida'},
  {value: 'closed', label: 'Cerrada'}
];

const STATE_LABELS = Object.fromEntries(
  TRAFFIC_LIGHT_STATES.map(state => [state.value, state.label])
);

const EVIDENCE_TYPE_LABELS = {
  general: 'Mensaje general',
  concertacion: 'Concertación',
  socializacion: 'Socialización',
  incidencia: 'Acción de incidencia',
  sesion: 'Sesión'
};

function formatDateTime(value) {
  if (!value) return '';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '';
  return new Intl.DateTimeFormat('es-CO', {
    timeZone: 'America/Bogota',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit'
  }).format(date);
}

function safeSpreadsheetText(value) {
  const text = String(value ?? '');
  return /^[=+\-@]/.test(text) ? `'${text}` : text;
}

export function buildTrafficLightExportRows(records = [], mediators = []) {
  const mediatorsById = new Map(
    mediators.map(mediator => [Number(mediator.id), mediator])
  );

  return records.map(record => {
    const mediatorId = Number(record.mediatorId ?? record.mediator_id);
    const mediator = mediatorsById.get(mediatorId) || {};
    const evidenceType = record.evidenceType ?? record.evidence_type;
    const meetingOrder = record.meetingOrder ?? record.meeting_order;
    return {
      Estado: STATE_LABELS[record.trackingState] || record.trackingState || '',
      Mediador: safeSpreadsheetText(record.mediatorName ?? record.mediator_name ?? mediator.fullName),
      'Tipo de mediador': safeSpreadsheetText(mediator.roleName),
      'Tipo de solicitud': EVIDENCE_TYPE_LABELS[evidenceType] || evidenceType || '',
      Grupo: safeSpreadsheetText(record.groupCode ?? record.group_code),
      Sesión: meetingOrder || '',
      Institución: safeSpreadsheetText(record.schoolName ?? record.school_name),
      Observación: safeSpreadsheetText(record.observations),
      'Fecha de solicitud': formatDateTime(record.requestedAt ?? record.requested_at),
      'Fecha límite': formatDateTime(record.dueAt ?? record.due_at),
      'Fecha de respuesta': formatDateTime(record.respondedAt ?? record.responded_at),
      'Fecha de cierre': formatDateTime(record.closedAt ?? record.closed_at),
      Revisor: safeSpreadsheetText(record.reviewerName ?? record.reviewer_name)
    };
  });
}

export function downloadTrafficLightExcel({records, mediators, startDate, endDate}) {
  const rows = buildTrafficLightExportRows(records, mediators);
  const worksheet = XLSX.utils.json_to_sheet(rows);
  worksheet['!cols'] = [
    {wch: 22}, {wch: 30}, {wch: 22}, {wch: 20}, {wch: 16}, {wch: 10},
    {wch: 32}, {wch: 55}, {wch: 22}, {wch: 22}, {wch: 22}, {wch: 22}, {wch: 30}
  ];
  if (worksheet['!ref']) worksheet['!autofilter'] = {ref: worksheet['!ref']};

  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, 'Semáforo');
  XLSX.writeFile(workbook, `semaforo_${startDate}_a_${endDate}.xlsx`);
}
